import { render, staticRenderFns } from "./global-prompt.vue?vue&type=template&id=64c64419&scoped=true&"
import script from "./global-prompt.vue?vue&type=script&lang=js&"
export * from "./global-prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c64419",
  null
  
)

export default component.exports